import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-372cf615"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Fechar")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center banner_inicial" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/app-002.png" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-text-center font-suls" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "150",
    src: "/assets/img/logo.svg"
  })
], -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "descricao"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ver-mais" }, " Ver mais ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ChangeEndereco = _resolveComponent("ChangeEndereco")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_Searchbar = _resolveComponent("Searchbar")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_Produto = _resolveComponent("Produto")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_FooterMenu = _resolveComponent("FooterMenu")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.isOpen
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOpen(false))),
                        size: "small",
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.icon_location }, null, 8, ["icon"]),
                          _hoisted_1
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ChangeEndereco, {
            onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.stopCategorias())),
            onOnBack: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goBackEndereco())),
            onOnDismiss: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getEnderecos())),
            data: _ctx.currentEnderecos
          }, null, 8, ["data"]),
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openMenu())),
                        size: "large",
                        color: "jauservelayoutalter",
                        fill: "#fff"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            color: "jauservelayoutalter",
                            slot: "icon-only",
                            icon: _ctx.iconMenu
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "2" }),
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Searchbar, {
                        onOnSearch: _ctx.goToSearch,
                        data: { search: true, 'cart': false}
                      }, null, 8, ["onOnSearch"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_swiper, {
                slidesPerView: 'auto',
                spaceBetween: 5,
                centeredSlides: true
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onlyTopBanner(_ctx.banners), (banner, index) => {
                    return (_openBlock(), _createBlock(_component_swiper_slide, {
                      onClick: ($event: any) => (_ctx.processaBanner(banner)),
                      style: {"width":"80%"},
                      key: 'banner_'+index,
                      class: "banner-image"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          style: {"width":"100%","border-radius":"15px"},
                          src: banner.url
                        }, null, 8, _hoisted_4)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "12",
                    class: "categorias-item"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_swiper, {
                        slidesPerView: 'auto',
                        spaceBetween: 5,
                        centeredSlides: false
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onlySubBanner(_ctx.banners), (banner, index) => {
                            return (_openBlock(), _createBlock(_component_swiper_slide, {
                              onClick: ($event: any) => (_ctx.processaBanner(banner)),
                              style: {"width":"45%"},
                              key: 'banner_sub_'+index
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  style: {"width":"100%"},
                                  src: banner.url
                                }, null, 8, _hoisted_6)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "12",
                    class: "categorias-item"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_swiper, {
                        slidesPerView: 4,
                        spaceBetween: 10,
                        centeredSlides: false,
                        freeMode: false
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onlyCategoria(_ctx.categorias), (categoria, index) => {
                            return (_openBlock(), _createBlock(_component_swiper_slide, {
                              onClick: ($event: any) => (_ctx.navigate('/categoria/'+categoria.id_jau)),
                              key: 'c'+index,
                              class: _normalizeClass(['cor_radius cor_azul_layout', "categoria-item ion-text-center"])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_thumbnail, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    (categoria.name == ' ')
                                      ? (_openBlock(), _createBlock(_component_ion_skeleton_text, {
                                          key: 0,
                                          animated: true
                                        }))
                                      : (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          style: {"width":"100%"},
                                          src: _ctx.getIconeCat(categoria)
                                        }, null, 8, _hoisted_8))
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    (categoria.name == ' ')
                                      ? (_openBlock(), _createBlock(_component_ion_skeleton_text, {
                                          key: 0,
                                          animated: true,
                                          style: {"width":"100%"}
                                        }))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(categoria.name), 1))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categorias, (categoria, index) => {
                return (_openBlock(), _createBlock(_component_ion_row, {
                  key: 'c'+index
                }, {
                  default: _withCtx(() => [
                    (categoria.name)
                      ? (_openBlock(), _createBlock(_component_ion_col, {
                          key: 0,
                          size: "8",
                          class: _normalizeClass(["ion-no-padding font-montserrat", 'cor_h_layout'])
                        }, {
                          default: _withCtx(() => [
                            (categoria.name == ' ')
                              ? (_openBlock(), _createBlock(_component_ion_skeleton_text, {
                                  key: 0,
                                  animated: true,
                                  style: {"width":"100%","height":"20px"}
                                }))
                              : (categoria.name)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                    _createVNode(_component_ion_icon, {
                                      color: "jauservelayout",
                                      icon: _ctx.iconRight
                                    }, null, 8, ["icon"]),
                                    _createTextVNode(_toDisplayString(categoria.name), 1)
                                  ]))
                                : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (categoria.id_jau!='')
                      ? (_openBlock(), _createBlock(_component_ion_col, {
                          key: 1,
                          size: "4",
                          onClick: ($event: any) => (_ctx.processaVerMais(categoria))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_swiper, {
                          slidesPerView: 3,
                          spaceBetween: 30,
                          centeredSlides: false,
                          freeMode: false,
                          modules: _ctx.modules
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoria.produtos, (produto, index) => {
                              return (_openBlock(), _createBlock(_component_swiper_slide, {
                                key: 'c'+index,
                                class: "produto"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Produto, { produto: produto }, null, 8, ["produto"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modules"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_FooterMenu, { data: {inicial:false} })
    ]),
    _: 1
  }))
}